import React, { useState } from 'react';

import FormField from '../../../FormField';
import Tag from '../../../Tag';

const ProjectTag = ({ edit, tag, color }) => {
  const [tagValue, setTag] = useState(tag);
  // TO DO - handle change + handle errors
  const handleTag = e => {
    setTag(e.target.value);
  };

  return (
    <>
      {edit ?
        // <FormField label="Project Tag" id="project_tag">
        //   <select id="project_tag" onChange={handleTag}>
        //     <option>{tagValue}</option>
        //   </select>
        // </FormField>
        ""
        : <Tag color={color}>{tag}</Tag>}
    </>
  )
}

export default ProjectTag;